import { Component, ComponentRef, ElementRef, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicFormComponent } from '../../../../dynamic-form/dynamic-form.component';
import { CommonModule } from '@angular/common';
import { AccordionTableComponent } from '../../../../accordion-table/accordion-table.component';
import { ConfirmDialogV2Component } from '../../../../confirm-dialog/confirm-dialog-v2.component';
import { VerticalTabsComponent } from '../../../../vertical-tabs/vertical-tabs.component';
import { FormGroup } from '@angular/forms';
import { DynamicForm } from '../../../../../models/dynamic-form';
import { TableHeaderAndData } from '../../../../../models/table-header-and-data';
import { JobOrderFormActions } from '../job-order-renderer/job-order-renderer.component';
import { DynamicFormService } from '../../../../../services/dynamic-form.service';
import { convertEpochToISTDateTime } from '../../../../../utils/date-time-utils';
import { MultiSelectComponent } from '../../../../select/multi-select.component';
import { DocumentTypeDataListReq } from '../../../../../constants/finance-constants';
import { OperationService } from '../../../../../services/operations.service';
import { InventoryService } from '../../../../../services/inventory-service';
import { LoadingService } from '../../../../../services/loading.service';
import { ToasterService } from '../../../../../services/toaster.service';
import { AutocompleteDropdownComponent } from '../../../../autocomplete-dropdown/autocomplete-dropdown.component';
import { SharedModule } from '../../../../../modules/shared/shared.module';
import { SvgIconComponent } from '../../../../svg-icon/svg-icon.component';
import {JobOrderInventory, JobOrderVendorService } from '../../../../../models/job-orders.interface';
import { InventoryType } from '../../../../../constants/app-constants';
import { VendorAccordionContentComponent } from '../../vendor-accordion-content/vendor-accordion-content.component';
import { Container } from '../../../../../models/container.interface';
import { ImportCargoItem } from '../../../../../models/cargo-item.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, forkJoin, Observable, of, switchMap } from 'rxjs';
import { CommonUtils } from '../../../../../utils/common-utils';
import { JobOrderService } from '../../../../../services/job.order.service';
import { ServiceType } from '../../../../../constants/master-constants';

@Component({
  selector: 'app-ssr-job-order',
  standalone: true,
  imports: [DynamicFormComponent,
      CommonModule,
      AccordionTableComponent,
      ConfirmDialogV2Component,
      MultiSelectComponent,
      AutocompleteDropdownComponent,
      SvgIconComponent,
      SharedModule,
      VerticalTabsComponent],
  templateUrl: './ssr-job-order.component.html',
  styleUrl: './ssr-job-order.component.scss'
})
export class SsrJobOrderComponent implements JobOrderFormActions {
  @Input() processCycle!: string;
  @Input() jobOrderType!: string;
  @Input() jobOrderId!: string;
  @Input() jobOrderConfig!: any;

  jobOrderForm!: FormGroup;
  dynamicForm!: DynamicForm;

  cargoTableData: TableHeaderAndData = {headers: [], data: []};
  containerTableData: TableHeaderAndData = {headers: [], data: []};


  itemList: any = [];
  containerList: any = [];

  viewMode: boolean = false;
  editMode: boolean = false;

  private vendorMap: Map<string, JobOrderVendorService[]> = new Map();
  private initialInventoryMap: Map<string, string> = new Map();
  private initialVendorIds: Set<string> = new Set();

  private sectionMap: Map<string, any> = new Map();
  loadedAccordianIndexSet: Set<string> = new Set();

  documentTypeList: any[] = [];
  searchQuery: string = "";
  searchResult: any = {};
  filterKey: string = "";
  selectedContainerDocumentType: any = {};
  selectedCargoDocumentType: any = {};
  selectedCargo: any = {};

  selectedTab: string = "basicDetailsSection";
  tabList: any[] = [
    {
      id: "basicDetailsSection",
      label: "JO details",
      subtitle: "Please fill Issue and valid Dates",
      icon: "job_order.svg"
    },
    {
      id: "cargoSection",
      label: "Item details",
      subtitle: "Select cargo(s) and services",
      icon: "package.svg"
    },
    {
      id: "containerSection",
      label: "Container Details",
      subtitle: "Select container(s) and services",
      icon: "cube.svg"
    }
  ];

  @ViewChild("basicDetailsSection") basicDetailsSection: ElementRef | undefined;
  @ViewChild("cargoSection") cargoSection: ElementRef | undefined;
  @ViewChild("containerSection") containerSection: ElementRef | undefined;

  @ViewChild("cargoTableAccordion", { static: false })
  cargoTableAccordion?: AccordionTableComponent;
  @ViewChild("containerTableAccordion", { static: false })
  containerTableAccordion?: AccordionTableComponent;

  constructor(private dynamicFormSerice: DynamicFormService,
    private inventoryService: InventoryService,
    private loadingService: LoadingService,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
    private operationService: OperationService,
    private jobOrderService: JobOrderService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.jobOrderForm = new FormGroup({});
    this.documentTypeList = Object.values(DocumentTypeDataListReq);
  }

  ngOnInit() {
    this.cargoTableData.headers = this.jobOrderConfig.cargoTableHeaders;
    this.cargoTableData.data = this.itemList;

    this.containerTableData.headers = this.jobOrderConfig.containerTableHeaders;
    this.containerTableData.data = this.containerList;
    this.dynamicForm = this.jobOrderConfig.jobOrderFormElements;

    this.dynamicFormSerice.addControlsToForm(this.jobOrderForm, this.dynamicForm);

    if (this.jobOrderId === "") {
      this.viewMode = false;
      this.editMode = false;
      this.setDefaultValues();
      return;
    }

    if (this.route.snapshot.url[0].path === "edit") {
      this.editMode = true;
      this.viewMode = false;
    } else {
      this.editMode = false;
      this.viewMode = true;
    }
    this.loadJobOrderData(this.jobOrderId);
  }

  ngAfterViewInit() {
    if (this.basicDetailsSection)
      this.sectionMap.set("basicDetailsSection", this.basicDetailsSection.nativeElement);
    if (this.cargoSection)
      this.sectionMap.set("cargoSection", this.cargoSection.nativeElement);
    if (this.containerSection)
      this.sectionMap.set("containerSection", this.containerSection.nativeElement);
  }

  setDefaultValues() {
    this.jobOrderForm.get("issueDate")?.setValue(convertEpochToISTDateTime(new Date().getTime()));
  }

  selectTab(sectionId: string) {
    this.selectedTab = sectionId;
    const section = this.sectionMap.get(sectionId);
    const container = document.querySelector(".full_page_container");

    if (section && container) {
      const sectionTop = section.getBoundingClientRect().top - container.getBoundingClientRect().top;
      container.scrollTo({top: sectionTop + container.scrollTop, behavior: "smooth"});
    }
  }

  handleContainerDeletion(event: { rowId: string; rowIndex: number }) {
    this.vendorMap.delete(event.rowId);
    this.loadedAccordianIndexSet.delete(event.rowId);
  }

  handleCargoDeletion(event: { rowId: string; rowIndex: number }) {
    this.vendorMap.delete(event.rowId);
    this.loadedAccordianIndexSet.delete(event.rowId);
  }

  onCargoDocumentTypeSelection(documentType: any) {
    console.log('Cargo Docment Type: ', documentType);
    this.selectedCargoDocumentType = documentType;
  }

  onContainerDocTypeSelection(documentType: any) {
    console.log('Cpont Docment Type: ', documentType);
    this.selectedContainerDocumentType = documentType;
  }

  onSearchSelection(result: any) {
    this.searchResult = result;
  }

  clearSearch() {
    this.searchResult = {};
  }

  fetchCargo() {
    if (!this.selectedCargoDocumentType) {
      this.toasterService.error("Please select a document type");
      return;
    }
    if (!this.searchResult) {
      this.toasterService.error("Please enter a document No");
      return;
    }
    const key = this.selectedCargoDocumentType.key === 'CONTAINER_NUMBER' ? 'id' : this.selectedCargoDocumentType.lookupDetails.bindLabel;
    const request = {
      documentType: this.selectedCargoDocumentType.key,
      documentId: this.searchResult[key],
    }
    this.loadingService.show();
    this.inventoryService.fetchCargoByDocument(request).subscribe({
      next: (res: any) => {
        if (res.data.length === 0) {
          this.toasterService.error("No cargo found for the selected document type and ID");
          this.loadingService.hide();
        } else {
          this.itemList.push(...res.data);
          this.cargoTableData.data = this.itemList;
        }
        this.searchQuery='';
        this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.toasterService.error(err.error.errorDesc);
        this.loadingService.hide();
      }
    });
  }

  fetchContainer() {
    if (!this.selectedContainerDocumentType) {
      this.toasterService.error("Please select a document type");
      return;
    }
    if (!this.searchResult) {
      this.toasterService.error("Please enter a document No");
      return;
    }
    const key = this.selectedContainerDocumentType.key === 'CONTAINER_NUMBER' ? 'id' : this.selectedContainerDocumentType.lookupDetails.bindLabel;
    const request = {
      documentType: this.selectedContainerDocumentType.key,
      documentId: this.searchResult[key],
    }
    this.loadingService.show();
    this.inventoryService.fetchContainerByDocument(request).subscribe({
      next: (res: any) => {
        if (res.data.length === 0) {
          this.toasterService.error("No container found for the selected document type and document No");
          this.loadingService.hide();
        } else {
          this.containerList.push(...res.data);
          this.containerTableData.data = this.containerList;
        }
        this.searchQuery='';
        this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.toasterService.error(err.error.errorDesc);
        this.loadingService.hide();
      }
    });
  }

  configureServiceForCargo() {
    if (this.itemList.length === 0) {
      this.toasterService.error("Please select a cargo");
      return;
    }
    const inventoryOptions = this.itemList.map((item: any) => ({key: item.id, value: item.igmItemNo}));
    this.jobOrderService.openServicePanel(
      this.viewContainerRef,
      inventoryOptions,
      InventoryType.CARGO,
      ServiceType.SPECIAL_SERVICE,
      null,
      (service, ids) => {
        this.jobOrderService.addServiceToInventory(this.vendorMap, this.containerList, service, ids, InventoryType.CARGO);
      }
    );
  }

  configureServiceForContainer() {
    if (this.containerList.length === 0) {
      this.toasterService.error("Please select a container");
      return;
    }

    const inventoryOptions = this.containerList.map((item: any) => ({key: item.id, value: item.containerNo}));
    this.jobOrderService.openServicePanel(
      this.viewContainerRef,
      inventoryOptions,
      InventoryType.CONTAINER,
      ServiceType.SPECIAL_SERVICE,
      null,
      (service, ids) => {
        this.jobOrderService.addServiceToInventory(this.vendorMap, this.containerList, service, ids, InventoryType.CONTAINER);
      }
    );
  }

  loadTableAccordion(event: any, inventoryTypeString: string) {
    const rowId = event.rowId;
    const rowIndex = event.rowIndex;
    const inventoryType = inventoryTypeString === "CARGO" ? InventoryType.CARGO : InventoryType.CONTAINER;
    if (this.loadedAccordianIndexSet.has(rowId)) return;

    const inventoryId = inventoryType == InventoryType.CONTAINER ? this.containerList[rowIndex].id : this.itemList[rowIndex].id;

    if (!this.vendorMap.has(inventoryId)) {
      this.vendorMap.set(inventoryId, []);
    }
    const accordionContentInput = {
      serviceList: this.vendorMap.get(inventoryId),
      inventoryType: inventoryType,
      readonly: this.viewMode
    };
    const accordionComponent: AccordionTableComponent | undefined = inventoryType == InventoryType.CONTAINER ? this.containerTableAccordion : this.cargoTableAccordion;
    if (!accordionComponent) return;

    const accordionRef = accordionComponent?.loadComponent(
      VendorAccordionContentComponent,
      rowIndex,
      accordionContentInput,
    );
    if (accordionRef && 'instance' in accordionRef) {
      const componentRef = accordionRef as ComponentRef<VendorAccordionContentComponent>;
      componentRef.instance.serviceListChanged.subscribe((updatedList: JobOrderVendorService[]) => {
        this.vendorMap.set(inventoryId, updatedList);
      });
    }
    this.loadedAccordianIndexSet.add(rowId);
  }

  loadContainerAccordion(event: any) {

  }

  loadJobOrderData(jobOrderId: string) {
    this.loadingService.show();
    this.operationService.getJobOrderByIdLite(jobOrderId).pipe(
      switchMap((response: any) =>
        this.operationService.fetchJORelatedInventories(response?.data, {
          containerService: (ids) => this.inventoryService.getContainerList(CommonUtils.buildIdFilterRequest(ids)),
          cargoService: (ids) => this.operationService.getImportCargoList(CommonUtils.buildIdFilterRequest(ids)),
        })
      ),
      finalize(() => this.loadingService.hide())
    ).subscribe({
      next: (result: { jobOrder: any; containers?: any; cargos?: any }) => {
        const containers = result.containers?.data?.records ?? [];
        const cargos = result.cargos?.data?.records ?? [];
        this.hydrateForm(result.jobOrder, containers, cargos);
      },
      error: (error) => {
        console.error(error);
        this.toasterService.error("Failed to get job order data");
      }
    });
  }


  hydrateForm(jobOrderData: any, containers: Container[], cargos: ImportCargoItem[]) {
    let associatedContainerMap: Map<string, JobOrderInventory> = new Map();
    jobOrderData.jobOrderInventoryList.forEach((inventory: JobOrderInventory) => {
      if (inventory.inventoryId && inventory.joInvId) {
        this.initialInventoryMap.set(inventory.inventoryId, inventory.joInvId);
      }
      if (inventory.inventoryType === "CONTAINER") {
        associatedContainerMap.set(inventory.inventoryId, inventory);
      }
      if (inventory?.jobOrderServiceList) {
        this.vendorMap.set(inventory.inventoryId, inventory.jobOrderServiceList);
        inventory.jobOrderServiceList.forEach((service: JobOrderVendorService) => {
          if (service.id) {
            this.initialVendorIds.add(service.id);
          }
        })
      }
    });

    this.itemList = cargos;
    this.containerList = containers;
    this.cargoTableData.data = this.itemList;
    this.containerTableData.data = this.containerList;

    this.jobOrderForm.patchValue({
      ...jobOrderData,
      ...jobOrderData?.additionalDetails,
      expiryDate: convertEpochToISTDateTime(jobOrderData?.expiryDate),
      issueDate: convertEpochToISTDateTime(jobOrderData?.issueDate)
    });

    if (this.viewMode) {
      this.jobOrderForm.disable();
    }
  }

  saveForm(): void{
    this.jobOrderForm.markAllAsTouched();
    const jobOrderRequest = this.createJobOrderRequest();
    console.log("Inside Save", jobOrderRequest);
    const jobOrder$ = this.editMode
                      ? this.operationService.updateJobOrder(this.jobOrderId, jobOrderRequest)
                      : this.operationService.saveJobOrder(jobOrderRequest);

    jobOrder$.subscribe({
      next: (response) => {
        this.toasterService.success("Successfully " + this.editMode ? "updated" : "created" + " the job order");
        this.goBack();
      },
      error: (error) => {
        console.log("Request failed:", error);
        this.toasterService.error(error.error.errorDesc);
      }
    });
  }

  createJobOrderRequest(): any {
    const jobOrderInventoryList: JobOrderInventory[] = this.createJobOrderInventory();
    const deletedJobOrderVendorIds = this.getDeletedVendorIds();

    return {
      jobOrderType: this.jobOrderType,
      operationalProcess: this.processCycle,
      expiryDate: new Date(this.jobOrderForm.get("expiryDate")?.value).getTime(),
      jobOrderInventoryList,
      deletedJobOrderVendorIds
    };
  }

  createJobOrderInventory(): JobOrderInventory[] {
    const containerInventories = (this.containerList ?? []).map((container: Container) => ({
      joInvId: this.initialInventoryMap.get(container.id),
      inventoryId: container.id,
      inventoryNo: container.containerNo,
      inventoryType: 'CONTAINER',
      jobOrderServiceList: this.vendorMap.get(container.id)
    }));

    const itemInventories = (this.itemList ?? []).map((cargo: ImportCargoItem) => ({
      joInvId: this.initialInventoryMap.get(cargo.id),
      inventoryId: cargo.id,
      inventoryNo: cargo.igmItemNo,
      inventoryType: 'CARGO',
      jobOrderServiceList: this.vendorMap.get(cargo.id)
    }));

    return [...containerInventories, ...itemInventories];
  }

  getDeletedVendorIds(): string[] {
    const currentVendorIds = new Set<string>();
    this.vendorMap.forEach((vendors) => {
      vendors.forEach((vendor: JobOrderVendorService) => {
        if (vendor.id) {
          currentVendorIds.add(vendor.id);
        }
      });
    });

    const deletedVendorIds: string[] = [];
    this.initialVendorIds.forEach((jovId) => {
      if (!currentVendorIds.has(jovId)) {
        deletedVendorIds.push(jovId);
      }
    });

    return deletedVendorIds;
  }

  cancel(): void {
    this.goBack();
  }

  goBack(): void {
    this.router.navigateByUrl("/manage-operations/import/job-orders");
  }

}
